import { createSelector } from 'reselect';
import map from './map';
import { DEFAULT_ASSET_PAGE_FEATURES, STATUS_TRACKING_PAGE_FEATURES } from '../config/constants';
import { getProjectId, getSelectedAssetType, getSelectedSummariesConfig } from '.';

const RECENT_ACTIVITY_WIDTH = '620px';

export const getVisiblePresenterComponents = createSelector(
  [
    map.visiblePresenterComponents,
    getProjectId,
    getSelectedAssetType,
    getSelectedSummariesConfig,
  ],
  (visiblePresenterComponents, projectId, selectedAssetType, selectedSummariesConfig) => {
    const projectComponents = visiblePresenterComponents?.[projectId];
    const assetTypeComponents = projectComponents?.[selectedAssetType.id];

    return assetTypeComponents || [
      'digitalTwin',
      'recentStatusChanges',
      ...selectedSummariesConfig.map(summary => summary.id),
    ];
  },
);

export const getPageFeatures = createSelector(
  [map.assetManagerId],
  assetManagerId => (assetManagerId === 'status_tracking'
    ? STATUS_TRACKING_PAGE_FEATURES : DEFAULT_ASSET_PAGE_FEATURES),
);

export const getRecentActivityWidth = createSelector(
  [
    getVisiblePresenterComponents,
  ],
  (visiblePresenterComponents) => {
    if (visiblePresenterComponents?.includes('recentStatusChanges')
    && !visiblePresenterComponents?.includes('digitalTwin')) {
      return '100%';
    }
    if (visiblePresenterComponents?.includes('digitalTwin')
      && !visiblePresenterComponents?.includes('recentStatusChanges')) {
      return '20px';
    }
    return RECENT_ACTIVITY_WIDTH;
  },
);

export const getSummariesCollapsed = createSelector(
  [
    map.summariesLayout,
    map.assetDetailsAssetId,
  ],
  (
    summariesLayout,
    assetDetailsAssetId,
  ) => summariesLayout === 'collapsed' || !!assetDetailsAssetId,
);

export const getSummariesDefault = createSelector(
  [
    map.summariesLayout,
    getVisiblePresenterComponents,
    map.presenterModeActive,
  ],
  (
    summariesLayout,
    visiblePresenterComponents,
    presenterModeActive,
  ) => {
    if (presenterModeActive) {
      return (visiblePresenterComponents?.includes('recentStatusChanges')
      || visiblePresenterComponents?.includes('digitalTwin'));
    }
    return summariesLayout === 'default';
  },
);

export const getSummariesFullscreen = createSelector(
  [
    map.presenterModeActive,
    getVisiblePresenterComponents,
  ],
  (
    presenterModeActive,
    visiblePresenterComponents,
  ) => {
    if (!presenterModeActive) return false;
    return (
      !visiblePresenterComponents?.includes('recentStatusChanges')
      && !visiblePresenterComponents?.includes('digitalTwin')
    );
  },
);
